import React, { useState, useMemo, useEffect } from 'react';
import Mape from './map';
import axios from 'axios';
import Prealoader from '../layout/Preloader';
import { useAppName } from '../../hooks/useSafeState';
import '../../../styles/components/agencies.css';

const Agencies = () => {
  const appName = useAppName();

  // - - - - 📍🗺️ Location Section 🗺️📍 - - - -

  // - - -  🌐 Location States 🌐  - - -
  const [infoTotal, setinfoTotal] = useState({});

  const [paises, setPaises] = useState({});
  const [{ card, mail, name }, setCard] = useState({
    card: false,
    mail: '',
    name: '',
  });

  const [privincias, setPrivincias] = useState({ value: false });
  const [localidad, setLocalidad] = useState({ value: false });
  const [zoom, setZoom] = useState(1);
  const [{ lat, lng, zm }, setDetailsExchange] = useState({
    lat: -32.603007999999996,
    lng: -53.376192,
    zm: 2,
  });
  let paisLiteral = 0;
  let provinciaLiteral = 0;
  let estadoLiteral = 0;
  const paisess = [
    { id: 1, pais: 'Argentina' },
    { id: 2, pais: 'Peru' },
    { id: 3, pais: 'Peru' },
    { id: 3, pais: 'Brasil' },
    { id: 4, pais: 'Portugal' },
  ];

  function showPosition(position) {
    const letitude = position.coords.latitude;
    const { longitude } = position.coords;

    setDetailsExchange({
      lat: letitude,
      lng: longitude,
    });
  }

  // - - -📍 Inicial Location 📍- - -
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert(
        'Debe permitir el acceso a la geolocalisacion en su navegador para habilitar esta funcion'
      );
    }
  }
  async function getLocations(a, b, c) {
    const res = await axios
      .get(
        `https://aplicaciones-dev.travelit.com.ar/api/v1/Aplicaciones/Sucursales/?paisId=${paisLiteral}&localidadId=${estadoLiteral}&provinciaId=${provinciaLiteral}&buscar=0&aplic3acionId=0`
      )
      .then((res) => {
        const log = res.data.object;
        const data = log;
        const dataPais = [];
        data.map((x) => dataPais.push(x.paisId));
        const resultPais = dataPais.filter((item, index) => {
          return dataPais.indexOf(item) === index;
        });
        setPaises(resultPais);
        setinfoTotal(log);
      });
  }

  // - - -📍 Country Location 📍- - -

  async function searchProv() {
    const res = await axios
      .get(
        `https://aplicaciones-dev.travelit.com.ar/api/v1/Aplicaciones/Sucursales/?paisId=${paisLiteral}&localidadId=${estadoLiteral}&provinciaId=${provinciaLiteral}&buscar=0&aplic3acionId=0`
      )
      .then((res) => {
        const log = res.data.object;
        const data = log;
        setDetailsExchange({
          lat: Number(data[0].latitud),
          lng: Number(data[0].longitud),
        });
        setZoom(4);
        const dataProvincia = [];
        data.map((x) => dataProvincia.push(x.provinciaId));
        const resultProvincia = dataProvincia.filter((item, index) => {
          return dataProvincia.indexOf(item) === index;
        });
        setPrivincias(resultProvincia);
      });
  }

  function onChanguePaisOption(value) {
    paisLiteral = value;
    searchProv();
  }

  // - - -📍 Provincia Location 📍- - -

  async function searchLoc() {
    const res = await axios
      .get(
        `https://aplicaciones-dev.travelit.com.ar/api/v1/Aplicaciones/Sucursales/?paisId=${paisLiteral}&localidadId=${estadoLiteral}&provinciaId=${provinciaLiteral}&buscar=0&aplic3acionId=0`
      )
      .then((res) => {
        const log = res.data.object;
        const data = log;
        setDetailsExchange({
          lat: Number(data[0].latitud),
          lng: Number(data[0].longitud),
        });
        setZoom(7);
        const dataLocalidad = [];
        data.map((x) => dataLocalidad.push(x.localidadId));
        const resultLocalidad = dataLocalidad.filter((item, index) => {
          return dataLocalidad.indexOf(item) === index;
        });
        setLocalidad(resultLocalidad);
      });
  }

  function onChangueProvinciaOption(value) {
    provinciaLiteral = value;
    searchLoc();
  }

  // - - -📍 Localidad Location 📍- - -

  async function searchFinish() {
    const res = await axios
      .get(
        `https://aplicaciones-dev.travelit.com.ar/api/v1/Aplicaciones/Sucursales/?paisId=${paisLiteral}&localidadId=${estadoLiteral}&provinciaId=${provinciaLiteral}&buscar=0&aplic3acionId=0`
      )
      .then((res) => {
        const log = res.data.object;
        const data = log;
        setZoom(10);
        setDetailsExchange({
          lat: Number(data[0].latitud),
          lng: Number(data[0].longitud),
        });
      });
  }

  function onChangueLocalidadOption(value) {
    estadoLiteral = value;
    searchFinish();
  }

  // - - - 🔛 Change Id for Name  🔛 - - -

  function compareCountryId(countryId) {
    const country = paisess.map((x) =>
      countryId == x.id ? <option value={x.id}>{x.pais}</option> : null
    );
    return country;
  }

  // - - -📍🖱️ Click Buttton Search Location 🖱️📍- - -

  async function getLocationsClick() {
    const res = await axios
      .get(
        `https://aplicaciones-dev.travelit.com.ar/api/v1/Aplicaciones/Sucursales/?paisId=${paisLiteral}&localidadId=${estadoLiteral}&provinciaId=${provinciaLiteral}&buscar=0&aplic3acionId=0`
      )
      .then((res) => {
        const log = res.data.object;
        const data = log;
        setinfoTotal(log);
      });
  }

  function getLocationsClickZona() {
    setZoom(10);
    getLocation();
  }

  function elClick() {
    getLocationsClick(paisLiteral, provinciaLiteral, estadoLiteral);
  }
  function elClickZona() {
    getLocationsClickZona(paisLiteral, provinciaLiteral, estadoLiteral);
  }

  useEffect(() => {
    getLocations(0, 0, 0);
    getLocation();
  }, []);

  function clck(a, b, c, d) {
    setCard({
      card: true,
      mail: c,
    });
  }

  return (
    <>
      {typeof infoTotal[0] !== 'undefined' ? (
        <div className='containerGeneral grid container md:bg-gray-300'>
          {/* BIG CARD */}
          <div className='grid grid-cols-12 gap-4 '>
            <div className='containerInfo w-full col-span-12 md:col-span-3'>
              <h1 className='text-center p-2'>
                Buscar tu agencia <b>Mundigea</b>{' '}
              </h1>
              {/* SELECS */}
              <div className='grid grid-cols-2  '>
                <div className='w-full col-span-2 lg:col-span-1 md:px-3 -mb-2 md:mb-0'>
                  <div className='relative'>
                    <select
                      className='block appearance-none rounded-lg shadow-md w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-1 my-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                      id='grid-state'
                      onChange={(e) => onChanguePaisOption(e.target.value)}
                    >
                      <option selected>Pais</option>
                      {paises.map((x) => compareCountryId(x))}
                    </select>
                  </div>
                </div>
                <div className='w-full col-span-2 lg:col-span-1 md:px-3 -mb-2 md:mb-0'>
                  <div className='relative'>
                    {privincias.value !== false ? (
                      <select
                        className='block appearance-none rounded-lg shadow-md w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-1 my-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='grid-state'
                        onChange={(e) => onChangueProvinciaOption(e.target.value)}
                      >
                        <option selected>Provincia</option>
                        {privincias.map((x) => (
                          <option key={x}>{x}</option>
                        ))}
                      </select>
                    ) : (
                      <select
                        className='block appearance-none rounded-lg shadow-md w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-1 my-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='grid-state'
                      >
                        <option selected>Provincia</option>
                      </select>
                    )}
                  </div>
                </div>
                <div className='w-full col-span-2 lg:col-span-1 md:px-3 -mb-2 md:mb-0'>
                  <div className='relative'>
                    {localidad.value !== false ? (
                      <select
                        className='block appearance-none rounded-lg shadow-md w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-1 my-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='grid-state'
                        onChange={(e) => onChangueLocalidadOption(e.target.value)}
                      >
                        <option selected>Localidad</option>
                        {localidad.map((x) => (
                          <option key={x}>{x}</option>
                        ))}
                      </select>
                    ) : (
                      <select
                        className='block appearance-none rounded-lg shadow-md w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-1 my-3 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
                        id='grid-state'
                      >
                        <option selected>Localidad</option>
                      </select>
                    )}
                  </div>
                </div>
                {/* BUTTONS */}
                <button
                  className='bg-blue-700 col-span-2 lg:col-span-1 hover:bg-blue-900 text-white font-bold p-2 md:-p-2 m-3 rounded-xl hidden md:inline shadow-lg'
                  onClick={() => elClick()}
                >
                  Buscar
                </button>
                <hr className='md:col-span-2 hidden md:inline' />
                <hr className='md:col-span-2 hidden md:inline' />
                <button
                  className='bg-blue-700 hover:bg-blue-900 text-white font-bold p-2 mx-4 my-2 rounded md:col-span-2 hidden md:inline'
                  onClick={() => elClickZona()}
                >
                  Buscar cerca de mi zona
                </button>
                <hr className='md:col-span-2 hidden md:inline' />
                <hr className='md:col-span-2 hidden md:inline' />
              </div>
              {/* <div>Se han encontrado x agencias Mundigea cerca tuyo</div> */}
              <div className='h-3/4 overflow-auto'>
                {/* CARD AGENCIES */}
                {card !== false ? (
                  <div>
                    <div className='cardAgencie hidden xl:block hovcard mt-2 bg-white rounded-xl shadow-md p-3 m-1 '>
                      <img
                        className='imgcard rounded-xl p-1 object-cover border-gray-50'
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS93vzEQ65xcpqFW6nFJSN2bxMWgJcOUH6yAQ&usqp=CAU'
                      />
                      <div className='px-2 pb-2'>
                        <h3 className='text-center '>
                          {' '}
                          <b>Agencia S.A.</b>
                        </h3>
                        <p className='text-sm p-0.5'>
                          <b>Email:</b> {mail}
                        </p>
                        <p className='text-sm p-0.5  '>
                          <b>Tel:</b> 2596-69586
                        </p>
                        <p className='text-sm p-0.5 '>
                          <b>Direccion:</b> 9 de Julio Nro 12320
                        </p>
                        <a className='text-sm p-0.5 ' href='www.google.com.ar'>
                          <b>Web: </b>www.agencia.com.ar
                        </a>
                      </div>
                    </div>
                    {/* MODAL AGENCIES */}
                    <div className='cardAgencie hovcardxs block xl:hidden fixed h-auto mt-2 z-20 ml bg-white top-1/4 left-1/5 transform rounded-xl p-3 m-1 shadow-md md:inset-x-60 md:inset-y-28'>
                      <img
                        className='imgcardxs rounded-xl p-1 object-cover border-gray-50'
                        src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS93vzEQ65xcpqFW6nFJSN2bxMWgJcOUH6yAQ&usqp=CAU'
                      />
                      <div className='px-2 pb-2'>
                        <h3 className='text-center '>
                          {' '}
                          <b>Agencia S.A.</b>
                        </h3>
                        <p className='text-sm p-0.5 '>
                          <b>Email:</b> {mail}
                        </p>
                        <p className='text-sm p-0.5   '>
                          <b>Tel:</b> 2596-69586
                        </p>
                        <p className='text-sm p-0.5 '>
                          <b>Direccion:</b> 9 de Julio Nro 12320
                        </p>
                        <a className='text-sm p-0.5 ' href='www.google.com.ar'>
                          <b>Web: </b>www.agncia.com.ar
                        </a>
                        <br />
                        <button
                          onClick={() => setCard({ card: false })}
                          className='bg-gray-100 col-span-2 lg:col-span-1 hover:bg-blue-900 text-white font-bold p-2 md:-p-2 my-4  w-full rounded-xl text-gray-700'
                        >
                          Cerrar
                        </button>
                        <br />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {/* MAPA */}
            <div className='containerMap col-span-12 py-3 md:col-span-9 py-3'>
              <Mape
                className='iframe'
                clck={clck}
                infoTotal={infoTotal}
                latitude={lat}
                longitude={lng}
                zm={zm}
                zoom={zoom}
              />
            </div>
          </div>
          <button
            className='bg-blue-700 hover:bg-blue-900 text-white shadow-lg font-bold p-2 mx-4 -my-8 rounded-xl md:col-span-2 md:hidden '
            onClick={() => elClickZona()}
          >
            Buscar cerca de mi zona
          </button>
        </div>
      ) : (
        <Prealoader />
      )}
    </>
  );
};

export default Agencies;
